import { useState, useRef, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { allProducts, productsData, firstProducts } from "../data/productsData";
import ProductHero from "./ProductHero";
import ProductNavigation from "./ProductNavigation";
import ProductOverview from "./ProductOverview";
import FeaturesAndSpecs from "./FeaturesAndSpecs";
import Applications from "./Applications";

export default function ProductDetailPage() {
  const { productId } = useParams();
  const navigate = useNavigate();
  const [activeCategory, setActiveCategory] = useState<"consumer" | "power">(
    "consumer"
  );
  const [isVisible, setIsVisible] = useState(false);

  const product = allProducts[productId as keyof typeof allProducts];
  const currentCategory =
    productId &&
    productsData.consumer[productId as keyof typeof productsData.consumer]
      ? "consumer"
      : "power";

  useEffect(() => {
    if (!productId) {
      navigate(`/products/${firstProducts.consumer}`, { replace: true });
      return;
    }

    setActiveCategory(currentCategory);
    setIsVisible(false);
    const timer = setTimeout(() => setIsVisible(true), 100);
    return () => clearTimeout(timer);
  }, [productId, currentCategory, navigate]);

  const handleCategorySwitch = (category: "consumer" | "power") => {
    setActiveCategory(category);
    navigate(`/products/${firstProducts[category]}`, { replace: true });
  };

  if (!product) {
    return (
      <div className="min-h-screen pt-20 flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <h1 className="text-4xl font-light text-gray-900 mb-4">
            Product Not Found
          </h1>
          <button
            onClick={() => navigate(`/products/${firstProducts.consumer}`)}
            className="px-8 py-3 bg-cyan-500 text-white rounded-lg hover:bg-cyan-600 transition-all duration-300 hover:scale-105"
          >
            Browse Products
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white">
      <ProductHero
        activeCategory={activeCategory}
        onCategorySwitch={handleCategorySwitch}
        isVisible={isVisible}
      />

      <ProductNavigation
        activeCategory={activeCategory}
        currentProductId={productId}
        productsData={productsData}
        allProducts={allProducts}
      />

      <ProductOverview product={product} />

      <FeaturesAndSpecs product={product} />

      <div className="lg:p-10 lg:px-28 md:px-16 sm:px-16 p-4">
        <Applications product={product} />
      </div>
    </div>
  );
}
